export default __webpack_public_path__ + "static/media/Banner.e36fa590.svg";